import React from 'react';
import { useBreakpoint } from '@uplift/ui-v2';
import { DesktopLargeLayout } from './DesktopLargeLayout.component';
import { PatientDetailsLayoutProps } from './types';
import { TabletPortraitLayout } from './TabletPortraitLayout.component';
import { PhonePortraitLayout } from './PhonePortraitLayout.component';
import { DesktopSmallLayout } from './DesktopSmallLayout.component';
import { useMediaQuery } from '@mui/material';
import { TabletSmallPortraitLayout } from './TabletSmallPortraitLayout.component';


export const useIsSmallTablet = () => useMediaQuery('(min-width: 600px) and (max-width: 780px)');

export const ResponsiveLayout: React.FC<PatientDetailsLayoutProps> = (props) => {
  const breakpoint = useBreakpoint();
  const isSmallTablet = useIsSmallTablet();

  if (breakpoint.lg) {
    return (
      <DesktopLargeLayout {...props} />
    );
  }

  if (breakpoint.md) {
    return (
      <DesktopSmallLayout {...props} />
    );
  }

  if (isSmallTablet) {
    return (
      <TabletSmallPortraitLayout {...props} />
    );
  }

  if (breakpoint.sm) {
    return (
      <TabletPortraitLayout {...props} />
    );
  }

  return (
    <PhonePortraitLayout {...props} />
  );
};
